import { createFileRoute } from '@tanstack/react-router';
import { InstapayReviewsPage } from '@/modules/payments/pages/InstapayReviewsPage';

export const Route = createFileRoute('/dashboard/payments/instapay/')({
  component: InstapayReviewsPage,
});
